module.exports = {
      id: "tablet-usage",
      viewBox: "0 0 18 22",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#tablet",
      toString: function () {
        return this.url;
      }
    }